/**
 * Safely converts a Firestore Timestamp (or a pending serverTimestamp plain
 * object {seconds, nanoseconds}) to a JS Date.
 *
 * Right after an optimistic local write with serverTimestamp(), Firestore may
 * return the field as a plain object before the server value resolves, so
 * calling .toDate() directly throws "toDate is not a function".
 */
export function tsToDate(ts: { toDate?(): Date; seconds?: number } | null | undefined): Date | null {
  if (!ts) return null;
  if (typeof ts.toDate === 'function') return ts.toDate();
  if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000);
  return null;
}
